import { COUNTRY_STRINGS as ORIGINLA_COUNTRY_STRINGS } from '@bingads-webui-campaign/ads-globalization';

export const COUNTRY_STRINGS = {
  ...ORIGINLA_COUNTRY_STRINGS,
  CN: _TL_('China'),
};
